/**
 * The page's viewport inside the Finpilot Notetaker app (#15177 round 3,
 * R3-G). The app renders its web view edge to edge, under the status bar,
 * so in app mode the page opts into `viewport-fit=cover`: the safe-area
 * insets then resolve to the device's, and the shared page shell (`Layout`,
 * in app mode) clears the status bar with `env(safe-area-inset-top)`; no
 * page pads for it itself. Outside app mode (the
 * browser, iOS Safari, a frame embed) the viewport stays as `index.html`
 * declares it, where the browser keeps content clear of the status bar.
 *
 * Called once at boot (`main.jsx`); an import does nothing.
 */
import type { EmbedMode } from "./embedMode";

const COVER = "viewport-fit=cover";

export function fitViewportToAppShell(
  doc: Document,
  mode: EmbedMode | null
): void {
  if (mode !== "app") return;
  const meta = doc.querySelector<HTMLMetaElement>('meta[name="viewport"]');
  if (!meta || meta.content.includes("viewport-fit")) return;
  meta.content = `${meta.content}, ${COVER}`;
}
